import cx from "classnames";

export function Link({ className, href, children }: { className?: string; href: string; children?: React.ReactNode }) {
  return (
    <a
      className={cx(
        "text-brand-green transition-colors text-sm hover:underline hover:underline-offset-4 hover:text-brand-green-darker px-0.5",
        className,
      )}
      href={href}
    >
      {children}
    </a>
  );
}
